'use strict';

function onThen (value) {
  return [null, value];
}

module.exports = onThen;
